import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ticket-container" }

import { computed, provide, reactive } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useStore } from 'vuex'
import { useSelectionStore } from '@/pinia/selection'
import { CreateTicket, createTicket } from '@/services/tickets.service'

import CreateTicketContent from '@/components/features/tickets/CreateTicketContent.vue'
import CreateTicketFooter from '@/components/features/tickets/CreateTicketFooter.vue'
import CreateTicketHeader from '@/components/features/tickets/CreateTicketHeader.vue'
import DividerHorizontal from '@/design-system/atoms/DividerHorizontal.vue'
import LayoutOverlay from '@/design-system/templates/LayoutOverlay.vue'

interface EMITS {
  (e: 'closeCreateTicketModal', val: boolean)
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ModalCreateTicket',
  emits: ["closeCreateTicketModal"],
  setup(__props, { emit: __emit }) {

const emits = __emit

const { t } = useI18n()
const store = useStore()
const selectionStore = useSelectionStore()
const { clickedEntityType } = storeToRefs(selectionStore)
const selectedObjectId = computed(() => {
  return store.getters.selectedObjectId
})

const formData = reactive<CreateTicket>({
  title: '',
  description: null,
  categoryId: '',
  typeId: '',
  // @ts-ignore // see type EntityType with allowed values – clickedEntityType can be other values if create would be enabled for other entities
  entityConnection: [{ id: selectedObjectId.value, entityType: clickedEntityType.value }], // Start with single, but could be multible in the future
  priority: 'LOWEST',
  status: 'NOT_IN_PROGRESS',
  startDate: null,
  dueDate: null
})
provide<CreateTicket>('formDataCreateErrand', formData)

function closeModal() {
  emits('closeCreateTicketModal', false)
}
async function handleCreateTicket() {
  if (!formData) return
  try {
    const ticket = await createTicket(formData)
    if (ticket) {
      store.commit('setInfoMessage', {
        type: 'success',
        message: `${t('general__data__ticket-created')}`
      })
      closeModal()
    }
  } catch (error) {
    store.commit('setInfoMessage', {
      type: 'error',
      message: `${t('general__data__ticket-create-failed')}`
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutOverlay, { onCloseOverlay: closeModal }, {
    default: _withCtx(() => [
      _createElementVNode("main", _hoisted_1, [
        _createVNode(CreateTicketHeader, {
          title: _unref(t)('general__data__new-ticket'),
          onCloseCreateTicketModal: closeModal
        }, null, 8, ["title"]),
        _createVNode(DividerHorizontal, { style: {"margin-bottom":"16px"} }),
        _createVNode(CreateTicketContent, { class: "ticket-container__content" }),
        _createVNode(CreateTicketFooter, {
          class: "ticket-container__footer",
          onCancelCreateTicket: closeModal,
          onCreateTicket: handleCreateTicket
        })
      ])
    ]),
    _: 1
  }))
}
}

})